import BaseProxy from './Proxy';

export default class PaymentTransactionsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/searchPaymentTransactions', parameters);
  }

  timeFrame() {
    return this.submit('get', `${this.endpoint}/timeFrame`);
  }

  bundlePurchase(transactionId) {
    return this.submit('get', `${this.endpoint}/${transactionId}/bundlePurchase`);
  }

  bundleUsage(transactionId) {
    return this.submit('get', `${this.endpoint}/${transactionId}/bundleUsage`);
  }
}
